import React, { useRef, useEffect } from "react";

const TextInput = ({
  id,
  label,
  value,
  onChange,
  disabled = false,
  invalid = false,
  required = false,
  labelPosition = "left", // "top" | "left"
}) => {
  const textareaRef = useRef(null);
  const isTop = labelPosition === "top";

  // Resize whenever the value changes
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [value]);

  return (
    <div
      className={`w-full mb-4 ${isTop
        ? "flex flex-col gap-1"
        : "flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4"
        }`}
    >
      <label
        htmlFor={id}
        className={`text-base ${disabled ? "font-small py-1" : "font-medium py-2"} text-black ${isTop ? "" : "whitespace-nowrap"
          }`}
      >
        {label}
        {required && <span className="text-red-500"> *</span>}
      </label>

      <textarea
        ref={textareaRef}
        id={id}
        disabled={disabled}
        value={value}
        onChange={onChange}
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck={false}
        className={`w-full px-0  border-0 border-b-2 overflow-hidden resize-none
          ${invalid ? "border-b-red-600 bg-red-50 ring-2 ring-red-300 focus:ring-red-400" : "bg-slate-50 border-b-gray-300"}
          focus:outline-none focus:ring-0 focus:border-b-indigo-500
          font-medium
          ${!isTop ? "sm:flex-1" : ""}
          ${disabled ? "!text-black !opacity-100 font-small py-1" : "font-medium py-2"}
        `}
      />
    </div>
  );
};

export default TextInput;
